import Superstore, { IndexedDB } from 'superstore';
import Raven from 'raven-js';
let storeInstance;
export const getSuperStoreInstance = () => {
  if (!storeInstance) {
    try {
      storeInstance = new Superstore({
        namespace: 'chatspot-widget-ui',
        backend: IndexedDB
      }).open().catch(error => {
        Raven.captureException(error, {
          extra: {
            component: 'storageProvider',
            action: 'IndexedDBStoreInit'
          }
        });
      });
    } catch (e) {
      Raven.captureException(e, {
        extra: {
          component: 'storageProvider',
          action: 'IndexedDBStoreInit'
        }
      });
      storeInstance = Promise.reject(e);
    }
  }
  return storeInstance;
};